<app-title title="Meine Anfragen" [actionButton]="actionButton"></app-title>

<app-row justify="end" class="mt-2">
  <app-col>
    <button
      [attr.aria-expanded]="showFilters"
      aria-controls="show-filters"
      mat-icon-button
      color="primary"
      (click)="showFilters = !showFilters"
    >
      <mat-icon> filter_list </mat-icon>
      <span class="cdk-visually-hidden">Filter anzeigen</span>
    </button>
  </app-col>
</app-row>

<app-expander-animation
  [isExpanded]="showFilters"
  id="show-filters"
  [formGroup]="filters"
>
  <app-row class="mb-5">
    <app-col xs="12">
      <mat-form-field class="w-100" appearance="fill">
        <mat-label>Standort</mat-label>
        <mat-select formControlName="locationFilter" name="location">
          <mat-option value="">Alle</mat-option>

          @if (!(locations$ | async)?.length) {
            <mat-option disabled> Lade… </mat-option>
          }

          @for (location of locations$ | async; track location) {
            <mat-option [value]="location.id">
              {{ location.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </app-col>

    <app-col xs="12">
      <mat-form-field class="w-100" appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select
          [multiple]="true"
          formControlName="inquiryStatus"
          name="inquiryStatus"
        >
          @for (status of INQUIRY_STATUSES; track status) {
            @if (status !== 'OFFERS') {
              <mat-option [value]="status">
                {{ inquiryStatusMap[status]?.name }}
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    </app-col>

    <app-col xs="12">
      <mat-slide-toggle formControlName="onlyWithOffers">
        Nur Anfragen mit Angeboten anzeigen
      </mat-slide-toggle>
    </app-col>
  </app-row>
</app-expander-animation>

<app-row class="mt-4">
  <app-col xs="12">
    @if (inquiries$ | loading | async) {
      <app-loading />
    }
    @if (
      !(inquiries$ | async)?.length && (inquiries$ | loading | async) === false
    ) {
      <app-empty-placeholder> Anfragen </app-empty-placeholder>
    }
  </app-col>

  @if (filteredInquiries$ | async; as inquiries) {
    @for (inquiry of inquiries; track inquiry) {
      @if (isQuotationValid(inquiry.quotationDeadline)) {
        <app-col xs="12" class="mb-5">
          <app-producer-inquiry-card
            [inquiry]="inquiry"
            (reload)="fetchInquiries()"
          ></app-producer-inquiry-card>
        </app-col>
      }
    }
  }
</app-row>

@if ((filteredInquiries$ | async)?.length) {
  <app-title title="Bereits abgelaufene Anfragen"></app-title>
}

<app-row class="mt-4">
  @if (filteredInquiries$ | async; as inquiries) {
    <ng-container class="mouseflow-ignore">
      @for (inquiry of inquiries; track inquiry) {
        @if (isQuotationExpired(inquiry.quotationDeadline)) {
          <app-col xs="12" class="mb-5">
            <app-producer-inquiry-card
              [inquiry]="inquiry"
              (reload)="fetchInquiries()"
            ></app-producer-inquiry-card>
          </app-col>
        }
      }
    </ng-container>
  }
</app-row>
